<!--Basics of this component
1) Gathers the minimum data needed to create a new person.
2) Posts that data
3) Once post completed provides info on what to do next
4) Goes to person detail for new person

-->

<template>
  <div>
    <b-modal
      id="person-create"
      title="Add new member"
      @hidden = "cancelModal()"
      :busy="false"
      return-focus="body"
    >
      <template  v-slot:modal-footer="{}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="secondary" @click="cancelModal()">
          Cancel
        </b-button>
        <b-button v-if="formError.length == 0" size="md" variant="success" @click="buildValidPostPayload()">
          Save
        </b-button>
      </template>

      <div v-if="error != null" class="text-center">
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        <div v-html="error.data"></div>
      </div>
      
      <div v-if="formError.length > 0" class="text-center">
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        <div v-for="(item, key) in formError" :key="key">{{ item.error }}</div>
        <b-button variant="success" @click="formError = []">OK</b-button>
      </div>
      <b-form-group
        id="firstName-1"
        description="Enter members first name."
        label="First Name"
        label-for="input-1"
        :invalid-feedback="invalidFeedbackFirstName"
        :valid-feedback="validFeedbackFirstName"
        :state="stateFirstName"
      >
        <b-form-input
          id="input-1"
          v-model="firstName"
          :state="stateFirstName"
          trim
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="lastName-1"
        description="Enter members last name."
        label="Last Name"
        label-for="input-2"
        :invalid-feedback="invalidFeedbackLastName"
        :valid-feedback="validFeedbackLastName"
        :state="stateLastName"
      >
        <b-form-input
          id="input-2"
          v-model="lastName"
          :state="stateLastName"
          trim
        ></b-form-input>
      </b-form-group>

      <b-form-group lable="Consents">
        <b-form-checkbox-group
          v-model="selected"
          :options="options"
          switches
          stacked
          size="lg"
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      test: "this is the AddPersonHome.vue component",
      firstName: null,
      lastName: null,
      selected: [],
      formError: [],

      options: [
        { text: "Consent to travel.", value: "consentToTravel" },
        { text: "Internal Media", value: "internalMediaConsent" },
        { text: "External Media", value: "externalMediaConsent" },
        { text: "GDPR", value: "gdprConsent" },
        { text: "Member considered disabled", value: "consideredDisabled" },
        { text: "Active Member", value: "activeMember" },
      ],
    };
  },

  computed: {
    
    error() {
      return this.$store.getters.axiosError;
    },
    stateFirstName() {
      if (this.firstName == null) {
        return null;
      }
      if (this.firstName.length > 0) {
        return true;
      }
      return false;
    },
    stateLastName() {
      if (this.lastName == null) {
        return null;
      }
      if (this.lastName.length > 2) {
        return true;
      }
      return false;
    },
    invalidFeedbackFirstName() {
      if (this.stateFirstName == null || this.stateFirstName == true) {
        return null;
      }
      return "Enter at least on charecter";
    },
    validFeedbackFirstName() {
      if (this.stateFirstName == null || this.stateFirstName == false) {
        return null;
      }
      return "Thanks";
    },

    invalidFeedbackLastName() {
      if (this.stateLastName == null || this.stateLastName == true) {
        return null;
      }
      return "Enter at least on charecter";
    },
    validFeedbackLastName() {
      if (this.stateLastName == null || this.stateLastName == false) {
        return null;
      }
      return "Thanks";
    },

    personId() {
      return this.$store.getters.person.id;
    },
  },

  methods: {
    buildValidPostPayload() {
      let payload = {};

      for (let i = 0; i < this.options.length; i++) {
        const key = this.options[i].value;
        const value = this.selected.includes(key);
        payload[key] = value;
      }
      // now add first and last names
      payload.firstName = this.firstName;
      payload.lastName = this.lastName;
      // now add currentMember always true for new members
      payload.currentMember = true;
      // Now check gdpr is set to true, without this consent the person cannot be added to the database
      if (payload.gdprConsent == false) {
        this.formError.push({
          error: "You cannot add anyone to the system without GDPR consent",
        });
      }
      if (this.stateFirstName != true) {
        this.formError.push({ error: "Check first name." });
      }
      if (this.stateLastName != true) {
        this.formError.push({ error: "Check last name." });
      } else {
        this.postNewPerson(payload);
      }
    },
    postNewPerson(dataPayload) {
      const payload = {
        url: this.$store.getters.urlPrefix + "api/person/",
        data: dataPayload,
        mutationName: "person",
      };
      // now send it
      this.$store.dispatch("genericPostApiCall", payload)
      .then((resolve)=>{
        const personId = resolve.data.id;
        this.cancelModal();
        this.$router.push({name:"personDetail",params:{id:personId}})
      });

    },
    cancelModal(){
      this.firstName = null;
      this.lastName = null;
      this.selected = [];
      this.formError= [];
      this.$bvModal.hide('person-create')
    }
    
  },
};
</script>

<style scoped></style>
